var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionOutlinedAr = function SvgQuestionOutlinedAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#C29B40",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#questionOutlinedAR_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.003 13a.75.75 0 0 0 .75-.75v-.82A2.67 2.67 0 0 0 9.293 9a1.63 1.63 0 1 1 2.34-1.47.75.75 0 1 0 1.5 0 3.14 3.14 0 0 0-3.69-3.08A3.15 3.15 0 0 0 6.923 7a3.11 3.11 0 0 0 1.72 3.38 1.17 1.17 0 0 1 .61 1.06v.82a.75.75 0 0 0 .75.74M10.003 15.59a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "questionOutlinedAR_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgQuestionOutlinedAr;